export default "__VITE_ASSET__z0S7B6RS__"